import Vue from 'vue'
import Router from 'vue-router'
import Homepage from '@/views/Homepage/Homepage'
import Doctor from '@/views/Doctor/Doctor'
import Center from '@/views/YxzCenter/YxzCenter'
import User from '@/views/User/User'
import About from '@/views/About/About'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Homepage',
      component: Homepage,
      redirect: 'doctor',
      children: [
        {
          path: 'doctor',
          component: Doctor
        }, {
          path: 'center',
          component: Center
        }, {
          path: 'user',
          component: User
        }, {
          path: 'about',
          component: About
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js